// extracted by mini-css-extract-plugin
export default {"popoverAction":"ellipsis-actions_popoverAction__iHhUC","options":"ellipsis-actions_options__eJpz7","popover":"ellipsis-actions_popover__GRK0G"};